import { injectable } from 'inversify'

import { UniqueEntityID } from '../core'
import { BaseState } from './BaseState'

export interface RouteStateUserToWaypointsInfo {
  bearing?: number
  routeDirection?: number

  // Infos about the current waypoint from the waypoint before
  distanceStage?: number
  timeToStage?: number
  fuelConsumptionStage?: number
  etaStage?: Date

  // Infos about the current waypoint from the cumulative route
  altitudeOnRoute?: number
  distanceOnRoute?: number
  timeToOnRoute?: number
  fuelConsumptionOnRoute?: number
  etaOnRoute?: Date
}

export interface RouteStateVerticalInfo {
  // Infos about the current position to the top of climbing
  distanceToToc?: number
  timeToToc?: number
  fuelConsumptionToToc?: number
  etaToToc?: Date

  // Infos about the current position to the top of descent
  distanceToTod?: number
  timeToTod?: number
  fuelConsumptionToTod?: number
  etaToTod?: Date

  // The index position of top of climbing and top of descent in the route
  tocIndex?: number
  todIndex?: number
}

export interface RouteNavigationStateProps {
  /**
   * Information from user to every route waypoint for planning
   */
  userToWaypointInfo: Map<UniqueEntityID, RouteStateUserToWaypointsInfo>

  /**
   * Vertical Information from first route waypoint to the last for planning
   */
  verticalInfo: RouteStateVerticalInfo
}

const INITIAL_STATE: RouteNavigationStateProps = {
  userToWaypointInfo: null,
  verticalInfo: null
}

@injectable()
export class RouteNavigationState extends BaseState<RouteNavigationStateProps> {
  constructor() {
    super(INITIAL_STATE)
  }

  setUserToWaypointInfo(userToWaypointInfo: Map<UniqueEntityID, RouteStateUserToWaypointsInfo>) {
    this._updateStateProp('userToWaypointInfo', userToWaypointInfo)
  }

  setVerticalInfo(verticalInfo: RouteStateVerticalInfo) {
    this._updateStateProp('verticalInfo', verticalInfo)
  }

  resetWaypointInfo() {
    this.updateState({
      userToWaypointInfo: null
    })
  }

  resetVerticalInfo() {
    this.updateState({
      verticalInfo: null
    })
  }
}
